import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const PolymarketTradeVolumeTriggerDetails = ({ trigger, triggerType }: Props) => {
  const conditionId = trigger.context?.conditionId || 'N/A';

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Market ID" value={conditionId} />
    </div>
  );
};
